export default __webpack_public_path__ + "static/tujo-logo-white-98f3ccc822fb6cabe0099700e6d472e2.png";